// Fold-based minimum / maximum of an array.
//
// `Math.min(...array)` / `Math.max(...array)` pass every element as a separate function ARGUMENT, so a large array
// -- the tens of thousands of manufacturing-line dimensions or scores a big listing produces, in either the /mcc
// tree or the legacy Quote Builder one -- overflows the engine's call-stack argument limit and throws
// "RangeError: Maximum call stack size exceeded". These fold the array instead: linear cost, constant stack depth,
// safe at any size.
//
// An empty array returns the identity (Infinity / -Infinity), matching Math.min() / Math.max() with no arguments,
// so callers that guard on length or combine with a floor (e.g. Math.max(1, maximumOf(values))) behave unchanged.

export function minimumOf(values) {
  let minimum = Infinity;
  for (const value of values) {
    if (value < minimum) {
      minimum = value;
    }
  }
  return minimum;
}

export function maximumOf(values) {
  let maximum = -Infinity;
  for (const value of values) {
    if (value > maximum) {
      maximum = value;
    }
  }
  return maximum;
}
